import { FunctionComponent, h } from 'preact';
import { Localizer } from 'preact-i18n';

import { Properties } from '../../../common';

export interface ExpanderProps extends Properties {
  expanded: boolean;
  onExpand: () => any;
  ariaControls: string;
  ariaLabel?: h.JSX.Element | string;
}

export const Expander: FunctionComponent<ExpanderProps> = (props: ExpanderProps) => {
  const { ariaControls, ariaLabel, children, expanded, onExpand } = props;

  return (
    <Localizer>
      <button
        class={props.class}
        onClick={onExpand}
        aria-haspopup
        aria-controls={ariaControls}
        aria-expanded={expanded}
        aria-label={ariaLabel}
      >
        {children}
      </button>
    </Localizer>
  );
};
